<div data-note-id="{{id}}" data-status="{{status}}">
  <div class="note-comments">
    {{#each comments}}
    <div class="tile">
      <div class="tile-content">
        <div class="tile-title note-badges">
          <div class="flex-center-items">
            {{{badges.user}}}
            {{{badges.age}}}
            {{{badges.status}}}
          </div>
          {{#if @first}}
          {{#unless @reduced}}
          <div class="flex-no-shrink ml-auto btn-group">
            {{{../badges.report}}}
            {{#if ../watchlist}}
              {{{../badges.unwatch}}}
            {{else}}
              {{{../badges.watch}}}
            {{/if}}
            {{{../badges.hide}}}
          </div>
          {{/unless}}
          {{/if}}
        </div>
        <p class="tile-subtitle text-break">{{{html}}}</p>
      </div>
    </div>
    <div class="divider"></div>
    {{/each}}

    <div class="form-group requires-authentication">
      <textarea class="form-input note-comment" rows="3"
                placeholder="{{localizer 'comments.inputPlaceholder'}}"></textarea>
      <!-- IMPORTANT: These elements must stay at this position, otherwise the automatic detection of the neighboring element will fail -->
      <div class="btn-group btn-group-block my-2 d-invisible note-comment-actions">
        <button class="btn comment-action" data-action="comment">{{localizer 'action.comment'}}</button>
        <button class="btn comment-action" data-action="close">{{localizer 'action.commentClose'}}</button>
        <button class="btn comment-action" data-action="reopen">{{localizer 'action.commentReopen'}}</button>
      </div>
    </div>
  </div>

  <div class="divider requires-authentication"></div>

  {{#unless @reduced}}
  <div class="note-actions">
    {{> actions actions}}
  </div>
  {{/unless}}
</div>
